import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';  

@Injectable({
  providedIn: 'root'
})
export class BannerAlertService {

  sharingData = new Subject();  

  constructor() { }
}
